import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Container, NavBar } from '@/components';
import { AdSlot } from '@/components/GoogleAds/AdSlot';
import { PencilIcon } from '@/components/Navbar/Icons';
import useAuth from '@/hooks/useAuth';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import { usePermutive } from '@/hooks/usePermutive';
import ROUTES from '@/router/routes';
import { AdsSections } from '@/types/ads';
import { letterGenderById } from '@/utils';
import { ADS_DIV_ID, SECTION_NAME_FOR_ADS } from '@/utils/ads';

type Props = {
  main: () => React.ReactNode;
  sidebar: () => React.ReactNode;
  title: string;
  trackSection?: AdsSections;
};

export const Layout = ({ main, sidebar, title, trackSection }: Props) => {
  const navigate = useNavigate();
  const { isMobile } = useIsDesktop();

  const { userInitialData } = useAuth();

  const { trackPageView, isReady: isPermutiveReady } = usePermutive();

  useEffect(() => {
    // Permutive esta cargado
    if (isPermutiveReady) {
      trackPageView({
        section: trackSection || SECTION_NAME_FOR_ADS.miequipo,
        kw_premium: userInitialData?.premium,
        kw_edad: userInitialData?.edad_dt,
        kw_sexo: letterGenderById(userInitialData?.idSexo),
        kw_equipo: userInitialData?.club_hincha,
        kw_fecha: userInitialData?.fechaActiva.orden,
        kw_pines: userInitialData?.pinesDisponibles,
        kw_saldo: userInitialData?.saldo,
        kw_puntosporfecha: userInitialData?.puntos_fecha,
        kw_puntosportorneo: userInitialData?.puntos_general,
        kw_posicionporfecha: userInitialData?.posicion_fecha,
        kw_posicionportorneo: userInitialData?.posicion_general,
        kw_recibirinfo: userInitialData?.recibeInformacion,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPermutiveReady]);
  return (
    <NavBar
      desktop
      mobile={{
        leftContent: {
          showMenuAction: true,
          items: true,
        },
        centerContent: {
          title,
        },
        rightContent: {
          customRightContent: (
            <button
              className="rounded-[.63rem] bg-gdt-gray-9 w-8 h-8 flex justify-center items-center"
              onClick={() => navigate(ROUTES.editAccount.myData)}
            >
              <PencilIcon />
            </button>
          ),
        },
      }}
    >
      <Container
        className="relative py-[0.56rem] space-y-[0.81rem]"
        variant="default"
      >
        {/* banners top */}
        <AdSlot divId={ADS_DIV_ID.horizontal} variant="HORIZONTAL" />
        <div className="flex lg:gap-4 flex-col lg:flex-row">
          <main className="w-full flex-1">{main()}</main>
          <aside className="lg:max-w-[348px] w-full">{sidebar()}</aside>
        </div>
        {/* banners footer */}
        {isMobile && (
          <AdSlot className="mx-auto" divId={ADS_DIV_ID.caja1} variant="BOX" />
        )}
      </Container>
    </NavBar>
  );
};

export default Layout;
